'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/lang/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _constants = require('../../../constants');

require('./FilterBar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _antd.Select.Option;
var RangePicker = _antd.DatePicker.RangePicker;
var FilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FilterBar, _Component);

  function FilterBar(props) {
    (0, _classCallCheck3.default)(this, FilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterBar.__proto__ || (0, _getPrototypeOf2.default)(FilterBar)).call(this, props));

    _initialiseProps.call(_this);

    var _props$filters = props.filters,
        _props$filters$filter = _props$filters.filterRange,
        filterRange = _props$filters$filter === undefined ? "TODAY" : _props$filters$filter,
        _props$filters$startT = _props$filters.startTime,
        startTime = _props$filters$startT === undefined ? null : _props$filters$startT,
        _props$filters$endTim = _props$filters.endTime,
        endTime = _props$filters$endTim === undefined ? null : _props$filters$endTim,
        _props$filters$lastNd = _props$filters.lastNdays,
        lastNdays = _props$filters$lastNd === undefined ? null : _props$filters$lastNd;


    _this.state = {
      searchTerm: "",
      startTime: startTime,
      endTime: endTime,
      lastNdays: lastNdays,
      filterDropdownSelected: filterRange,
      disableApplyFilter: true,
      showApplyFilter: false,
      showRefresh: true
    };
    return _this;
  }

  (0, _createClass3.default)(FilterBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var filterDropdownSelected = this.state.filterDropdownSelected;
      var filterRange = nextProps.filters.filterRange;


      if (filterDropdownSelected !== filterRange) {
        var _nextProps$filters = nextProps.filters,
            startTime = _nextProps$filters.startTime,
            endTime = _nextProps$filters.endTime,
            lastNdays = _nextProps$filters.lastNdays;

        this.setState({
          startTime: startTime,
          endTime: endTime,
          lastNdays: lastNdays,
          filterDropdownSelected: filterRange
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'FilterBar__Component' },
        this.renderDataFilter()
      );
    }
  }]);
  return FilterBar;
}(_react.Component), _class.propTypes = {
  createAction: _propTypes2.default.func.isRequired,
  filters: _propTypes2.default.shape({
    searchTerm: _propTypes2.default.string,
    filterRange: _propTypes2.default.string,
    startTime: _propTypes2.default.object,
    endTime: _propTypes2.default.object,
    lastNdays: _propTypes2.default.number
  }).isRequired,
  aggregateEventUpdateAvailable: _propTypes2.default.bool.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.submitFilter = function () {
    var _state = _this2.state,
        searchTerm = _state.searchTerm,
        startTime = _state.startTime,
        endTime = _state.endTime,
        lastNdays = _state.lastNdays,
        filterDropdownSelected = _state.filterDropdownSelected;

    var params = {
      searchTerm: searchTerm,
      filterRange: filterDropdownSelected,
      startTime: startTime,
      endTime: endTime,
      lastNdays: lastNdays,
      paginationSize: _constants.AGGREGATE_EVENTS_PAGINATION_SIZE
    };
    _this2.props.createAction('fetchAggregateEvents', params);
    _this2.setState({
      showApplyFilter: false,
      showRefresh: true
    });
  };

  this.searchInputChange = function (e) {
    var value = e.target.value;
    var _state2 = _this2.state,
        filterDropdownSelected = _state2.filterDropdownSelected,
        lastNdays = _state2.lastNdays,
        startTime = _state2.startTime,
        endTime = _state2.endTime;

    var disableApplyFilter = filterDropdownSelected === 'LAST_N_DAYS' ? lastNdays === null : filterDropdownSelected === 'DATE_RANGE' ? startTime === null && endTime === null : false;
    _this2.setState({
      searchTerm: value === "" ? null : value,
      showApplyFilter: true,
      showRefresh: false,
      disableApplyFilter: disableApplyFilter
    });
  };

  this.lastNDaysChange = function (value) {
    var noValue = value === undefined || value === "";
    _this2.setState({
      lastNdays: noValue ? null : value,
      disableApplyFilter: noValue,
      showApplyFilter: true,
      showRefresh: false,
      startTime: null,
      endTime: null
    });
  };

  this.rangePickerChange = function (value) {
    if (!(0, _isEmpty2.default)(value)) {
      _this2.setState({
        startTime: value[0],
        endTime: value[1],
        disableApplyFilter: false,
        showApplyFilter: true,
        showRefresh: false,
        lastNdays: null
      });
    } else {
      _this2.setState({
        startTime: null,
        endTime: null,
        disableApplyFilter: true,
        showApplyFilter: true,
        showRefresh: false
      });
    }
  };

  this.filterDropdownChange = function (value) {
    var isNewValue = _this2.state.filterDropdownSelected !== value;
    var secondFilterValueRequiredList = ['LAST_N_DAYS', 'DATE_RANGE'];
    var missingRequiredValue = secondFilterValueRequiredList.includes(value);
    _this2.setState({
      filterDropdownSelected: value,
      showApplyFilter: isNewValue,
      disableApplyFilter: missingRequiredValue,
      showRefresh: !isNewValue
    });
  };

  this.displayLastNDays = function () {
    return _react2.default.createElement(
      'div',
      { className: 'filter-bar-item' },
      _react2.default.createElement(
        'div',
        { className: 'filter-bar-item-label' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.enterNDays.label', defaultMessage: 'Enter Days (n)' })
      ),
      _react2.default.createElement(_antd.InputNumber, {
        min: 1,
        max: 90,
        style: { width: '100px' },
        onChange: function onChange(value) {
          return _this2.lastNDaysChange(value);
        }
      })
    );
  };

  this.displayRangePicker = function () {
    var _state3 = _this2.state,
        startTime = _state3.startTime,
        endTime = _state3.endTime;

    var maxDate = (0, _moment2.default)().local().startOf('day').subtract(90, 'days').valueOf();
    var todaysDate = (0, _moment2.default)().local().startOf('day').add(1, 'days').valueOf();
    var disabledDate = function disabledDate(evalDate) {
      return evalDate && (evalDate.valueOf() <= maxDate || evalDate.valueOf() >= todaysDate);
    };
    return _react2.default.createElement(
      'div',
      { className: 'filter-bar-item' },
      _react2.default.createElement(
        'div',
        { className: 'filter-bar-item-label' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.selectRange.label', defaultMessage: 'Select Range' })
      ),
      _react2.default.createElement(RangePicker, {
        style: { width: '200px' },
        format: 'MMM-DD-YY',
        allowClear: true,
        showTime: false,
        disabledDate: disabledDate,
        onChange: function onChange(value) {
          return _this2.rangePickerChange(value);
        },
        value: [startTime, endTime]
      })
    );
  };

  this.renderDataFilter = function () {
    var _state4 = _this2.state,
        disableApplyFilter = _state4.disableApplyFilter,
        filterDropdownSelected = _state4.filterDropdownSelected,
        showRefresh = _state4.showRefresh,
        showApplyFilter = _state4.showApplyFilter;
    var aggregateEventUpdateAvailable = _this2.props.aggregateEventUpdateAvailable;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'filter-bar-item' },
        _react2.default.createElement(
          'div',
          { className: 'filter-bar-item-label' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.selectDateRange.label', defaultMessage: 'Select Filter Date' })
        ),
        _react2.default.createElement(
          _antd.Select,
          {
            showSearch: false,
            style: { width: '150px' },
            defaultValue: filterDropdownSelected,
            value: filterDropdownSelected,
            onChange: function onChange(value) {
              return _this2.filterDropdownChange(value);
            }
          },
          _constants.DATA_RANGE.map(function (range) {
            return _react2.default.createElement(
              Option,
              { key: range.value, value: range.value },
              range.label
            );
          })
        )
      ),
      filterDropdownSelected === "LAST_N_DAYS" && _this2.displayLastNDays(),
      filterDropdownSelected === "DATE_RANGE" && _this2.displayRangePicker(),
      _react2.default.createElement(
        'div',
        { className: 'filter-bar-item' },
        _react2.default.createElement(
          'div',
          { className: 'filter-bar-item-label' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.search.label', defaultMessage: 'Search' })
        ),
        _react2.default.createElement(_antd.Input, { onChange: function onChange(e) {
            return _this2.searchInputChange(e);
          }, placeholder: 'Enter search keywords', style: { width: '150px' } })
      ),
      showApplyFilter && _react2.default.createElement(
        'div',
        { className: 'filter-bar-item' },
        _react2.default.createElement(
          _antd.Button,
          { disabled: disableApplyFilter, type: 'primary', onClick: _this2.submitFilter },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.applyFilter.label', defaultMessage: 'Apply Filter' })
        )
      ),
      showRefresh && _react2.default.createElement(
        'div',
        { className: 'filter-bar-item' },
        _react2.default.createElement(
          _antd.Tooltip,
          { visible: aggregateEventUpdateAvailable, placement: 'right', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FilterBar.autoUpdate.label', defaultMessage: 'New updates found. Please refresh to see latest activity.' }) },
          _react2.default.createElement(
            _antd.Badge,
            { dot: aggregateEventUpdateAvailable },
            _react2.default.createElement(
              _antd.Button,
              { onClick: _this2.submitFilter },
              _react2.default.createElement(_antd.Icon, { type: 'reload' })
            )
          )
        )
      )
    );
  };
}, _temp);
exports.default = FilterBar;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/modules/FilterBar/components/FilterBar.js
// module id = 3416
// module chunks = 2